import classNames from 'classnames/bind';
import styles from './BusinessSection.module.css';
import { motion, Variants } from 'framer-motion';
import useTranslation from 'next-translate/useTranslation';
import Trans from 'next-translate/Trans';

const cx = classNames.bind(styles);

const cardVariants: Variants = {
  offscreen: {
    y: 20,
  },
  onscreen: {
    y: 0,
    transition: {
      type: 'spring',
      bounce: 0.1,
      duration: 1.0,
    },
  },
};

function BusinessSection() {
  const { t } = useTranslation('business');
  return (
    <motion.section
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ once: true }}
    >
      <motion.div variants={cardVariants}>
        <section className={cx('main-wrapper')}>
          <h1>{t('business')}</h1>
        </section>
        <section className={cx('main-wrapper', 'content-wrapper')}>
          <div>
            <span>01</span>
            <h1>{t('content')}</h1>
          </div>
          <div>
            <span>02</span>
            <h1>{t('partnership')}</h1>
          </div>
          <div>
            <span>03</span>
            <h1>{t('merchandise')}</h1>
          </div>
        </section>
      </motion.div>
    </motion.section>
  );
}

export default BusinessSection;
